export const OPEN_POSITIONS = [
  { title: "Senior AI Engineer", location: "Remote · Global", type: "Full-time", team: "AI Platform" },
  { title: "Staff Software Engineer (Distributed Systems)", location: "New Delhi / Remote", type: "Full-time", team: "Platform" },
  { title: "Senior Product Designer", location: "Remote · Global", type: "Full-time", team: "Design" },
  { title: "React Native Engineer", location: "Remote · Global", type: "Full-time", team: "Mobile" },
  { title: "Engineering Manager — Web", location: "New Delhi / Remote", type: "Full-time", team: "Web" },
  { title: "Data Annotation Lead", location: "New Delhi", type: "Full-time", team: "Data Operations" },
  { title: "DevRel & Technical Writer", location: "Remote · Global", type: "Full-time", team: "Marketing" },
  { title: "SRE / Platform Engineer", location: "Remote · Global", type: "Full-time", team: "Platform" },
];

export const BENEFITS = [
  { title: "Remote-First", desc: "Work from anywhere. Quarterly team off-sites in Goa, Lisbon and Tokyo." },
  { title: "Health & Wellness", desc: "Best-in-class medical, dental, vision and mental health stipends for you and family." },
  { title: "Learning Budget", desc: "$2,500 / year for books, courses, conferences and certifications." },
  { title: "Equipment & Setup", desc: "Top-tier laptop, monitors and a $2,000 home-office grant." },
  { title: "Sabbatical", desc: "Four-week paid sabbatical after every three years." },
  { title: "Equity", desc: "Meaningful equity for every full-time employee. Long-window exercise on departure." },
];

export const CULTURE_VALUES = [
  { title: "Engineering Pride", desc: "We write code we are proud to read in five years." },
  { title: "Default to Honesty", desc: "Hard truths fast. Sugar-coating costs trust and time." },
  { title: "Customer Obsessed", desc: "We measure success in our customers' outcomes, not our hours billed." },
  { title: "Quiet Confidence", desc: "Strong opinions, loosely held. We earn rooms with substance, not volume." },
];
